import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arowhead-s",
  "use": "arowhead-s-usage",
  "viewBox": "0 0 9.94 5.68",
  "content": "<symbol viewBox=\"0 0 9.94 5.68\" id=\"arowhead-s\"><path class=\"cls-1\" d=\"M5 5.68l-5-5L.71 0 5 4.27 9.23 0l.71.71z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/arowhead-s.svg
// module id = 142
// module chunks = 0